// extracted by mini-css-extract-plugin
export var deleteIcon = "_px-5";
export var deleteOption = "_px-3";
export var divider = "_px-2";
export var downloadIcon = "_px-4";
export var drawer = "_px-0";
export var drawerFooter = "_px-6";
export var drawerOpen = "_px-1";
export var highlighted = "_px-7";
export var lighterHighlight = "_px-8";